import { combineReducers } from 'redux';
import authReducer from './auth/auth-reducer';
import alertReducer from './alert/alert-reducer';
import homeReducer from './home-screen/home-reducer';
import laboratoryReducer from './lab/lab-reducer';
import appointmentReducer from './appointment/appointment-reducer';
import financialReducer from './financials/financials-reducer';
import consultsReducer from '@store/consults/consults-reducer';
import clientOrdersReducer from './client/orders/orders-reducer';
import usersReducer from './users/users-reducer';
import contactInformationReducer from './client/contact-information/contact-information-reducer';
import blogsReducer from './blogs/blogs-reducer';
import homeCareReducer from './home-care/home-care-reducer';
import clientWalletReducer from './client/wallet/wallet-reducer';
import pharmaciesReducer from './pharmacies/pharmacies-reducer';
import basketReducer from './basket/basket-reducer';
import productsReducer from './products/products-reducer';
import messagesReducer from './client/messages/messages-reducer';
import clientComplaintsReducer from './client/complaints/complaints-reducer';
import commentsReducer from './client/comments/comments-reducer';

const rootReducer: any = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  home: homeReducer,
  lab: laboratoryReducer,
  appointment: appointmentReducer,
  finance: financialReducer,
  consults: consultsReducer,
  clientOrders: clientOrdersReducer,
  users: usersReducer,
  contactInfo: contactInformationReducer,
  blogs: blogsReducer,
  homeCare: homeCareReducer,
  clientWallet: clientWalletReducer,
  pharmacies: pharmaciesReducer,
  basket: basketReducer,
  products: productsReducer,
  messages: messagesReducer,
  clientComplaints: clientComplaintsReducer,
  comments: commentsReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>
